import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import FormBlock from "../../../components/form/FormBlock.vue";
import PaymentList from "../../../components/order/payments/PaymentList.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentBlock',
    props: /*@__PURE__*/ _mergeModels({
        disabled: Boolean,
        cashConfig: Object,
        systems: Array,
        error: String,
        sum: Number,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const value = _useModel(__props, "modelValue");
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormBlock, {
                disabled: __props.disabled,
                alwaysVisible: "",
                title: "Выберите способ оплаты"
            }, {
                default: _withCtx(() => [
                    _createVNode(PaymentList, {
                        systems: __props.systems,
                        error: __props.error,
                        sum: __props.sum,
                        cashConfig: __props.cashConfig,
                        modelValue: value.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                    }, null, 8 /* PROPS */, ["systems", "error", "sum", "cashConfig", "modelValue"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"]));
        };
    }
});
